













































































import {Component, Vue} from 'vue-property-decorator';
import ConfirmModal from "@/components/ConfirmModal.vue";
import * as firebase from 'firebase/app';
import {mapGetters} from "vuex";

@Component({
    name: "Privacy",
    components: {ConfirmModal},
    computed: {
        ...mapGetters({user: 'user', profile: 'profile'})
    },
})
export default class Privacy extends Vue {
    private modal_show: boolean = false;
    private user?: any;

    get modalShow() {
        return this.modal_show;
    }

    set modalShow(val: boolean) {
        if (!val) {
            (this.$refs.modal as Vue).$off('si');
            (this.$refs.modal as Vue).$off('no');
        }
        this.modal_show = val;
    }

    private deleteProfile(announcement_id: string) {
        new Promise((resolve, reject) => {
            (this.$refs.modal as Vue).$once('si', resolve);
            (this.$refs.modal as Vue).$once('no', reject);
            this.modalShow = true;
        }).then(() => {

            firebase.firestore().collection('users').doc(this.user.id).delete().then(
                ()=>{
                    /*let currentUser = firebase.auth().currentUser;
                    if (currentUser){
                        currentUser.delete()
                    }*/
                    this.$store.dispatch('signOut')
                }
            )
        }).catch(() => {
        }).finally(() => {
            this.modalShow = false
        })
    }
}

